<template>
  <gh-menu title="数据导入" btnText='数据导入'>
    <template>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <div>
            <span>导入场景：数据初始化过程，项目前项进行初始化操作，请按表样
              <v-btn flat small color="success" @click="downloadSample">
                点击下载
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
              要求进行导入！
            </span>
          </div>
          <v-alert v-model="alert" dismissible :type="result.type">
            {{result.msg}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <el-upload class="upload-demo" :action="requestUrl('uploadsample')" :on-success="onSuccess" :file-list="fileList" :before-upload="beforeUpload">
            <v-btn color="primary">
              上传文件
              <v-icon right dark>mdi-cloud-upload-outline</v-icon>
            </v-btn>
          </el-upload>
        </v-card-actions>
      </v-card>
    </template>
  </gh-menu>
</template>

<style scoped>

</style>

<script>
import GhImport from "./ghImport.ts";
export default GhImport;
</script>